import useStore from '../../store';
import shallow from 'zustand/shallow';
/**
 * Returns the active metric state and a setter function
 */

export default function useActiveMetric() {
  var _useStore = useStore(function (_ref) {
    var activeMetric = _ref.activeMetric,
        setStoreValues = _ref.setStoreValues;
    return [activeMetric, setStoreValues];
  }, shallow),
      activeMetric = _useStore[0],
      setStoreValues = _useStore[1];

  var setActiveMetric = function setActiveMetric(newMetric) {
    return setStoreValues({
      activeMetric: newMetric
    });
  };

  return [activeMetric, setActiveMetric];
}